import http from './http';

const prescriptionAPI = {
  // Create a new prescription
  createPrescription: async (prescriptionData) => {
    const response = await http.post('/api/v1/prescriptions', prescriptionData);
    return response.data;
  },

  // Get all prescriptions with filters
  getAllPrescriptions: async (params = {}) => {
    const response = await http.get('/api/v1/prescriptions', { params });
    return response.data;
  },

  // Get prescription by ID
  getPrescriptionById: async (id) => {
    const response = await http.get(`/api/v1/prescriptions/${id}`);
    return response.data;
  },

  // Get patient prescription history
  getPatientPrescriptions: async (patientId, params = {}) => {
    const response = await http.get(`/api/v1/prescriptions/patient/${patientId}`, { params });
    return response.data;
  },

  // Update prescription
  updatePrescription: async (id, prescriptionData) => {
    const response = await http.patch(`/api/v1/prescriptions/${id}`, prescriptionData);
    return response.data;
  },

  // Delete prescription
  deletePrescription: async (id) => {
    const response = await http.delete(`/api/v1/prescriptions/${id}`);
    return response.data;
  },

  // Get prescription statistics
  getPrescriptionStats: async () => {
    const response = await http.get('/api/v1/prescriptions/stats');
    return response.data;
  },

  // Get prescription in print format
  getPrescriptionPrint: async (id) => {
    const response = await http.get(`/api/v1/prescriptions/${id}/print`);
    return response.data;
  },

  // Get comprehensive patient report with prescription for an appointment
  getPatientReportWithPrescription: async (appointmentId) => {
    const response = await http.get(`/api/v1/prescriptions/appointment/${appointmentId}/patient-report`);
    return response.data;
  }
};

export default prescriptionAPI;
